import { Injectable } from "@angular/core";
import { factory } from "../shared/app-logging";
import { BehaviorSubject, Observable, catchError, map, publishReplay, refCount, throwError } from "rxjs";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { TemplatePriorityExportRequest, TemplatePriorityExportResponse } from "../model/template.priority.model";
import { environment } from "@/environments/environment";
import { AppConfig } from "../shared/app-config";
import { ErrorDataService } from "./error-data.service";

const logger = factory.getLogger('ExportService');

@Injectable({
  providedIn: 'root'
})
export class ExportService {

  private openExportModal: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private isExportEnabled: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private isLoadingActive: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private httpClient: HttpClient) { }

  public setOpenExportModal(value: boolean): void {
    this.openExportModal.next(value);
  }

  public getOpenExportModal(): BehaviorSubject<boolean> {
    return this.openExportModal;
  }

  public setIsExportEnabled(value: boolean): void {
    this.isExportEnabled.next(value);
  }

  public getIsExportEnabled(): BehaviorSubject<boolean> {
    return this.isExportEnabled;
  }

  public setIsLoadingActive(value: boolean): void {
    this.isLoadingActive.next(value);
  }

  public getIsLoadingActive(): BehaviorSubject<boolean> {
    return this.isLoadingActive;
  }

  public exportTemplatePriority(request: TemplatePriorityExportRequest): Observable<TemplatePriorityExportResponse> {
    return this.httpClient.post(environment.contentLibraryApiBaseUrl + AppConfig.urlTemplatePriorityExport, request)
      .pipe(
        map(
          (response: TemplatePriorityExportResponse) => {
            if (response.code != 200) {
              const errorMessage: string = 'An unexpected error occurred exporting TemplatePriorities: ' + response.message;
              logger.error(errorMessage);
              // const message = `In ExportService.exportTemplatePriority().`;
              // return throwError(ErrorDataService.overLoadError(new Error(errorMessage), message));
              response.code = 500;
            }
            return response;
          }
        ), catchError((err: Error | HttpErrorResponse) => {
          const message = `In ExportService.exportTemplatePriority().`;
          return throwError(ErrorDataService.overLoadError(err, message));
        }),
        // publishReplay(1),
        // refCount()
      );
  }

}
